import React from 'react';
import { cn } from '@chapche/ui';
import { XIcon } from '../appearence/icons/x_icon';
import { Tooltip } from './Tooltip';

const SelectWithTokensActiveItem = ({ selectItem, removeCallback }) => {
    return (
        <Tooltip content={selectItem.itemTitle}>
            <span key={selectItem.itemId + selectItem.included}
                className={cn(
                    'product__forms-item inline-flex items-center gap-4 rounded-sm px-8 py-4',
                    selectItem.included === false && 'product__forms-item_excluded',
                )}
                style={selectItem.getBulletStyle ? selectItem.getBulletStyle() : null}
                  onClick={(e) => e.preventDefault()} >
                <span className="block__bullet select__item-content">{selectItem.itemTitle}</span>
                <span onClick={() => selectItem.isLastItem ? null : removeCallback.deleteItem(selectItem.itemId)}>
                    <XIcon nameOfClass={`product__forms-item-icon ${selectItem.isLastItem ? 'product__forms-item_disabled' : ''}`} />
                </span>
            </span>
        </Tooltip>
    );
};

export default SelectWithTokensActiveItem;
